import { StatusIndicatorLevel } from '@aus-platform/design-system';
import { LayerType } from '../../../../../../shared/api';
import { FileStatus } from '../../../../../../shared/enums';
import {
  type HistogramDataType,
  type PointCloudDataType,
} from '../../../../../../shared/types';
import { PointShape } from '../sidecards/layer-properties-sidecard';

// Earth radius in meters (WGS84 equatorial radius)
export const EARTH_RADIUS_METERS = 6378137.0;

export const initialHistogramData: HistogramDataType = {
  rescale: null,
  opacity: 100,
  sourceFilePath: null,
};

export const initialPointCloudData: Required<PointCloudDataType> = {
  opacity: 100,
  pointSize: 5,
  pointShape: PointShape.Square,
};

export const canShowHistogramLayerTypesList = [
  LayerType.CapturedDsm,
  LayerType.SlopeMap,
];

export const FileStatusIndicatorMapping = {
  [FileStatus.Done]: StatusIndicatorLevel.Done,
  [FileStatus.Failed]: StatusIndicatorLevel.Failed,
  [FileStatus.Processing]: StatusIndicatorLevel.Processing,
  [FileStatus.Importing]: StatusIndicatorLevel.Importing,
  [FileStatus.ImportFailed]: StatusIndicatorLevel.Failed,
  [FileStatus.Starting]: StatusIndicatorLevel.Started,
};
